import React, { useEffect, useState } from "react";
import { Helmet } from 'react-helmet-async';
import LandingPageNavbar from "../components/LandingPageNavbar";
import CookieConsent from "../components/CookieConsent";
import { Container } from "react-bootstrap";
import Carousel from 'react-bootstrap/Carousel';
import Image1 from "../assets/images/home/image-1.jpg";
import Image2 from "../assets/images/home/image-2.jpg";
import Image3 from "../assets/images/home/image-3.jpg";
import Image4 from "../assets/images/home/image-4.jpg";
import Image5 from "../assets/images/home/image-5.jpg";
import Image6 from "../assets/images/home/image-6.jpg";
import Image7 from "../assets/images/home/image-7.jpg";
import Image8 from "../assets/images/home/image-8.jpg";

function Home({ setPageTitle }) {

  useEffect(() => {
    setPageTitle("Welcome to Bait Al Anaqah - The House of Elegance");
  }, [setPageTitle]);

  return (
    <>
      <Helmet>
        <meta name="keywords" content="Bait Al Anaqah, Bespoke, Uniforms, Alteration, Custom, Dubai" />
        <meta name="title" property="og:title" content={setPageTitle}></meta>
        <meta property="og:type" content="website" />
        <meta name="description" property="og:description" content="Experience the elegance of Bait Al Anaqah, where every creation tells a story and reflects your unique identity while honoring your values." />
        <meta name="image" property="og:image" content={Image2} />
        <link rel="canonical" href="https://baitalanaqah.com" />
      </Helmet>
      <LandingPageNavbar />
      <div className="vh-100 overflow-hidden bg-dark d-lg-block d-none">

        <Carousel fade controls={false} indicators={false}>
          <Carousel.Item>
            <img src={Image1} className="img-fluid" />
          </Carousel.Item>
          <Carousel.Item>
            <img src={Image2} className="img-fluid" />
          </Carousel.Item>
          <Carousel.Item>
            <img src={Image3} className="img-fluid" />
          </Carousel.Item>
          <Carousel.Item>
            <img src={Image4} className="img-fluid" />
          </Carousel.Item>
        </Carousel>
      </div>

      <div className="vh-100 overflow-hidden bg-dark d-lg-none d-block">
        <Carousel fade controls={false} indicators={false}>
          <Carousel.Item>
            <img src={Image5} className="img-fluid" />
          </Carousel.Item>
          <Carousel.Item>
            <img src={Image6} className="img-fluid" />
          </Carousel.Item>
          <Carousel.Item>
            <img src={Image7} className="img-fluid" />
          </Carousel.Item>
          <Carousel.Item>
            <img src={Image8} className="img-fluid" />
          </Carousel.Item>
        </Carousel>
      </div>
      <CookieConsent />
    </>
  );
}

export default Home;
